class a {
  url;
  target;
  defaultPrevented;
  constructor(e, t) {
    this.url = e, this.target = t, this.defaultPrevented = !1;
  }
  preventDefault() {
    this.defaultPrevented = !0;
  }
  isDefaultPrevented() {
    return this.defaultPrevented;
  }
}
export {
  a as NavigationEvent
};
//# sourceMappingURL=navigation-event.js.map
